<template>
  <v-app>
    <v-navigation-drawer disable-resize-watcher v-model="drawer" app>
      <template v-slot:prepend>
        <v-list-item>
          <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        </v-list-item>
      </template>

      <v-list dense>
        <v-list-item
          link
          v-for="item in menu"
          :key="item.icon"
          v-scroll-to="{ el: item.route, offset: -70 }"
          @click.prevent="drawer = false"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-uppercase">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar elevate-on-scroll app color="white">
      <v-container class="d-inline-flex">
        <div class="hidden-lg-and-up">
          <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        </div>
        <div class="d-flex align-center mr-12" v-if="logo">
          <v-img
            max-width="200"
            alt="MahamBet Logo"
            class="shrink mr-2"
            contain
            :src="'/images/' + logoImg"
            transition="scale-transition"
          />
        </div>

        <v-btn
          tile
          color="primary"
          v-scroll-to="{ el: item.route, offset: -70 }"
          class="hidden-md-and-down"
          text
          v-for="item in menu"
          :key="item.icon"
          height="50"
        >
          <span class="mr-2">{{ item.title }}</span>
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn color="primary" :href="'tel:' + contacts.phone" class="hidden-md-and-down" text height="50">
          <span class="mr-2 contact-link">{{ contacts.phone }}</span>
        </v-btn>
        <v-btn color="primary" :href="'mailto:' + contacts.email" class="hidden-md-and-down pr-0" text height="50">
          <span class="contact-link">{{ contacts.email }}</span>
        </v-btn>
      </v-container>
    </v-app-bar>

    <v-content>
      <v-container id="home-block">
        <sliderblock class="page-block" />
      </v-container>
      <v-container v-on:scroll.passive="logo = true" id="advantages-block">
        <advblock class="page-block" />
      </v-container>
      <v-container id="contacts-block">
        <contactblock :contacts="contacts" class="page-block" />
      </v-container>
      <v-container id="feedback-block">
        <feedbackform :contacts="contacts" class="page-block" />
      </v-container>
    </v-content>

    <v-footer color="white" class="pa-0" height="200">
      <v-container class="pa-0 primary">
        <v-row class="pa-0 primary" align="center" justify="center">
          <v-col cols="12" md="5">
            <v-card class="pa-2 primary" outlined tile>
              <v-card-title class="primary"
                ><span class="white--text" height="50"
                  >ТОО РИП Газ &copy; {{ new Date().getFullYear() }}</span
                ></v-card-title
              >
            </v-card>
          </v-col>

          <v-spacer></v-spacer>
          <v-col cols="12" md="2" class="pr-0">
            <v-card class="pa-2 primary" outlined tile>
              <v-card-title class="primary pr-0">
                <v-btn color="primary" :href="'tel:' + contacts.phone" class="white--text pl-0" text height="50">
                  <v-icon size="24px" class="white--text">mdi-phone</v-icon>
                  <span class="ml-1 white--text footer-contact-link">{{ contacts.phone }}</span>
                </v-btn></v-card-title
              >
            </v-card>
          </v-col>

          <v-col cols="12" md="4" class="pr-0">
            <v-card class="pa-2 primary" outlined tile>
              <v-card-title class="primary pr-0">
                <v-btn color="primary" :href="'mailto:' + contacts.email" class="white--text  pl-0" text height="50">
                  <v-icon size="24px" class="white--text">mdi-email</v-icon>
                  <span class="ml-1 white--text footer-contact-link">{{ contacts.email }}</span>
                </v-btn></v-card-title
              >
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import sliderblock from "./components/sliderblock";
import advblock from "./components/advblock";
import contactblock from "./components/contactblock";
import feedbackform from "./components/feedbackform";

export default {
  name: "App",
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: {
    sliderblock,
    advblock,
    contactblock,
    feedbackform
  },

  data: () => ({
    logoImg: "mblogo.png",
    drawer: false,
    logo: false,
    contacts: {
      phone: "+7 7122 763601",
      email: "parking@maham.bet"
    }
  }),

  computed: {
    menu() {
      let menuitems = [];
      if (this.logo) {
        menuitems = [
          { icon: "mdi-home", route: "#home-block", title: "Начало" },
          {
            icon: "mdi-message-outline",
            route: "#advantages-block",
            title: "Наши преимущества"
          },
          {
            icon: "mdi-text-box-check-outline",
            route: "#contacts-block",
            title: "Обратная связь"
          }
        ];
      } else {
        menuitems = [
          {
            icon: "mdi-message-outline",
            route: "#advantages-block",
            title: "Наши преимущества"
          },
          {
            icon: "mdi-text-box-check-outline",
            route: "#contacts-block",
            title: "Обратная связь"
          }
        ];
      }
      return menuitems;
    }
  },

  methods: {
    handleScroll() {
      this.logo = window.scrollY > 100;
    },
    headerStyle() {
      return window.scrollY > 100 ? null : { "margin-left": "15px" };
    }
  }
};
</script>

<style scoped>
span.footer-contact-link,
span.contact-link {
  font-weight: 700 !important;
}
.page-block {
  min-height: 500px !important;
}
</style>
